import React from "react";
import { PackageOpen } from "lucide-react";

export const EmptyState = ({ message, icon: Icon = PackageOpen, testId }) => (
  <div
    data-testid={testId}
    className="flex flex-col items-center justify-center rounded-lg border border-dashed border-forest/25 bg-beige/50 px-6 py-16 text-center"
  >
    <div className="mb-4 flex h-14 w-14 items-center justify-center rounded-full border border-forest/20 bg-white/70">
      <Icon className="h-6 w-6 text-forest/70" />
    </div>
    <p className="max-w-md font-body text-sm leading-relaxed text-espresso/70">{message}</p>
  </div>
);

export default EmptyState;
